import { Image } from '@nextui-org/react';
import { GENERIC_APP } from '../../config/generic';
import { SOS_APP } from '../../config/sos';

const MOHT_LOGO_SRC = process.env.PUBLIC_URL + '/logo_moht_row.png';

const disclaimer =
  process.env.REACT_APP_DEPLOYMENT_TYPE === 'GENERIC'
    ? GENERIC_APP.disclaimer
    : SOS_APP.disclaimer;

export default function Footer() {
  return (
    <div className="flex flex-row justify-end items-center w-full">
      <p className="mx-auto text-xs">{disclaimer}</p>
      <Image src={MOHT_LOGO_SRC} className="h-12 mx-2" />
    </div>
  );
}
